import axios from 'axios'
import React, { useState } from 'react'
import { BiLoaderAlt } from 'react-icons/bi'
import { MdArrowForwardIos } from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux'
import LogoNevula from '../assets/images/logo-nevula.svg'
import InputUpload from '../components/Inputs/InputUpload'
import useSnackBars from '../hooks/SnackbarConsumerHook'
import { changeFirstTime } from '../redux/actions/authentication'
import { RootState } from '../redux/store'
import { uploadDynamicFile, uploadToS3 } from '../utils/UploadFile'
import RegisterForm from './RegisterForm'

const server = process.env.REACT_APP_SERVER_URL

const StepRegistation: React.FC<IStepRegistration> = ({ onClick }) => {
  const [selectedPage, setSelectedPage] = useState<number>(0)

  const user = useSelector((state: RootState) => state.auth.user)

  const { addAlert } = useSnackBars()

  const [imageKYC, setImageKYC] = useState<any>(null)

  const [isKycLoading, setIsKycLoading] = useState<boolean>(false)

  const dispatch = useDispatch()

  const renderFooter = () => (
    <div className="flex flex-col items-end mt-10">
      <div className="flex flex-col items-center">
        <div className="flex flex-row mr-5">
          {[...new Array(user['custom:user_role'] === 'master' ? 4 : 2)].map(
            (_, i) => (
              <div
                key={i}
                className="mr-1"
                style={{
                  width: 15,
                  height: 15,
                  backgroundColor: i === selectedPage ? '#006AEA' : '#D9D9D9',
                  borderRadius: 20,
                }}
              ></div>
            )
          )}
        </div>

        <div className="flex flex-row mt-2">
          {/* <div
            className="flex flex-row mr-5 items-center"
            onClick={() => {
              let value = selectedPage - 1
              setSelectedPage(value)
              onClick(value)
            }}
          >
            <MdArrowBackIosNew className="mr-2" />
            
            <div className="cursor-pointer">Atrás</div>
          </div> */}

          <div
            className="flex flex-row items-center"
            onClick={async () => {
              if (user['custom:user_role'] === 'master') {
                if (selectedPage === 2) {
                  if (imageKYC) {
                    try {
                      setIsKycLoading(true)
                      await uploadDynamicFile(
                        imageKYC,
                        `${user['custom:tenant_id']}/kyc_id.jpeg`,
                        process.env.REACT_APP_S3_URL_DOCS
                      )
                      let resp = await axios.post(`${server}/kyc`, {})
                      if (resp?.data?.is_valid) {
                        const response = await axios.patch(
                          `${server}/user/tenant`,
                          {
                            isKyc: true,
                          }
                        )

                        setSelectedPage(3)
                      } else {
                        addAlert({
                          message:
                            'El documento que subiste, no es un documento de identidad válido, debe de ser un RIF o CI vigente',
                          status: 'error',
                          duration: 8000,
                        })
                      }
                    } catch (err: any) {
                      // if (err?.response?.data?.error === 'Error processing the document image') {
                      //   addAlert({
                      //     message: 'En este momento tenemos problemas para la validación, comunicate con soporte',
                      //     status: 'error',
                      //   })
                      //   return
                      // }
                      addAlert({
                        message:
                          'En este momento tenemos problemas para la validación, comunicate con soporte',
                        status: 'error',
                      })
                    } finally {
                      setIsKycLoading(false)
                    }
                    return
                  }

                  setSelectedPage(3)
                  return
                }

                if (selectedPage === 3) {
                  dispatch(changeFirstTime())
                  return
                }

                let value = selectedPage + 1
                setSelectedPage(value)
                onClick(value)
              } else {
                if (selectedPage === 1) {
                  dispatch(changeFirstTime())
                  return
                }
                let value = selectedPage + 1
                setSelectedPage(value)
                onClick(value)
              }
            }}
          >
            <div className="text-primary cursor-pointer">
              {user['custom:user_role'] === 'master'
                ? selectedPage === 3
                  ? 'Finalizar'
                  : 'Siguiente'
                : selectedPage === 1
                ? 'Finalizar'
                : 'Siguiente'}
            </div>
            <MdArrowForwardIos className="ml-2" />
          </div>
        </div>
      </div>
    </div>
  )

  const renderOptions = () => {
    if (selectedPage === 0) {
      return (
        <>
          <div className="flex flex-col items-center">
            <img src={LogoNevula} alt="zerux" />
            <h1 className="mt-5 text-center">¡Bienvenido a Zerux!</h1>
            {user['custom:user_role'] === 'master' && (
              <p className="mt-5 text-center font-normal text-gray-400 text-sm">
                Es momento de terminar de configurar tu cuenta, haz click en el
                botón "Siguiente".
              </p>
            )}
          </div>
          {renderFooter()}
        </>
      )
    }
    if (selectedPage === 1 && user['custom:user_role'] === 'master') {
      return (
        <RegisterForm
          onCancel={() => setSelectedPage(0)}
          onSubmit={async (values) => {
            // console.log('hacer peticion aca', values)
            // let date = new Date()
            // date.setMonth(date.getMonth() + 1)
            // let dateISO = date.toISOString()

            // let subscriptionEnd = dateISO.replace(/T.+/, '')
            let s3InfoResponse: { value: any } = { value: {} }

            let body = {
              realName: user['custom:real_name'],
              document: {
                documentType: values.document.documentType,
                document: values.document.document,
              },
              businessName: values.businessName,
              email: user['email']?.toLowerCase(),
              businessSocial: values.businessSocial,
              plan: user['custom:user_plan'],
              subscriptionEnd: user['custom:subscription_end'],
              subscriptionType: 'MONTHLY',
              phone: values.phone,
              address: {
                city: values.city,
                postalCode: values.postalCode,
                state: values.state,
                country: values.country,
              },
              cognitoSub: user['sub'],
              leadChannel: values?.leadChannel || null,
              invoiceMethod: values?.invoiceMethod || null,
            }
            if (values.image) {
              try {
                await uploadToS3(
                  values.image,
                  s3InfoResponse,
                  undefined,
                  user['custom:tenant_id']
                )
              } catch (err) {
                addAlert({
                  message: 'Error al subir imagen.',
                  status: 'error',
                })
              }
            }
            try {
              await axios.patch(`${server}/user/tenant`, {
                ...body,
                image: s3InfoResponse?.value?.Bucket
                  ? `https://${s3InfoResponse.value.Bucket}.s3.amazonaws.com/${s3InfoResponse.value.Key}`
                  : '',
              })
              //   dispatch(changeFirstTime())
              setSelectedPage(2)
              addAlert({
                message: 'Usuario creado satisfactoriamente.',
                status: 'success',
              })
            } catch (err) {
              addAlert({
                message: 'Error al crear el usuario.',
                status: 'error',
              })
            }
          }}
        />
      )
    }

    if (selectedPage === 2 && user['custom:user_role'] === 'master') {
      return (
        <>
          <h1>Proceso de verificación</h1>
          <p className="mt-5 text-center font-normal text-gray-400 text-sm">
            Para cumplir con la normativa del SENIAT y activar tu cuenta,
            completa la verificación legal. Debes subir una foto legible en
            formato PNG o JPEG de un documento que identifique tu negocio: RIF
            Jurídico, RIF Personal o, en su ausencia, Cédula de Identidad.{' '}
          </p>

          <p className="mt-5 text-center font-normal text-sm">
            <strong>
              Dispone de un plazo máximo de 7 días a partir de hoy para
              completar este proceso. Después de este periodo, el acceso a
              ciertas funcionalidades podría ser restringido hasta que su cuenta
              sea verificada.
            </strong>
          </p>

          <p className="text-center font-normal text-sm">
            <strong>
              Si no lo hace en este momento puede continuar en el módulo de
              "Configuración"
            </strong>
          </p>

          <div className="mt-5 flex flex-row items-center justify-center w-full">
            <InputUpload
              isCompressed={true}
              title="Sube el documento"
              fileType="image"
              handleImage={(img) => {
                setImageKYC(img)
              }}
              deleteImage={() => {
                setImageKYC(null)
              }}
              // containerClasses="xl:col-start-1 xl:row-span-3 xl:col-span-3 col-start-3 col-span-8 row-span-8 m-auto"
              imageClasses="rounded-md dark:border-gray-700"
              maxHeight="max-h-[250px]"
              size={6000000}
            />
          </div>
          {isKycLoading ? (
            <div className="flex flex-row items-center justify-end w-full mt-7">
              <BiLoaderAlt className="animate-spin text-primary" size={35} />
            </div>
          ) : (
            renderFooter()
          )}
        </>
      )
    }

    return (
      <>
        <h1>Utilizar Zerux es muy sencillo</h1>
        <p className="font-normal text-gray-400 text-sm mb-2 col-span-12 mb-5">
          A continuación podrás ver un breve tutorial que te ayudará a dar tus
          primeros pasos en la gestión de tu negocio con Zerux
        </p>

        <div className="flex justify-center items-center">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/xBh0uM4NcWI?si=72GFEhN6TmQDaojT"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          ></iframe>
        </div>

        {renderFooter()}
      </>
    )
    // return
  }

  return <div>{renderOptions()}</div>
}

interface IStepRegistration {
  onClick: (value: number) => void
}

export default StepRegistation
